import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';

import { ChartComponent } from './components/chart/chart.component';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { UploadClearedOfferDialogComponent } from './components/upload-cleared-offer-dialog/upload-cleared-offer-dialog.component';
import { SetCellsValueComponent } from './components/set-cells-value/set-cells-value.component';
import { AdjustCellsValueComponent } from './components/adjust-cells-value/adjust-cells-value.component';
import { OfferEntryGridComponent } from './components/offer-entry-grid/offer-entry-grid.component';
import {
    OfferSummaryConfirmationDialogComponent
} from './components/offer-summary-confirmation-dialog/offer-summary-confirmation-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatRadioModule, MatButtonToggleModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { NotificationComponent } from './components/notification-panel/notification-panel.component';
import { NotificationItemComponent } from './components/notification-item/notification-item.component';
import { AddRegistrationComponent } from './components/add-registration/add-registration.component';
import { UpdatePriceDialogComponent } from './components/update-price-dialog/update-price-dialog.component';
import { ProductSelectionComponent } from './components/product-selection/product-selection.component';

import { CellFocus } from './components/offer-entry-grid/cellFocus';

import { DataTablesModule } from 'angular-datatables';

import { ManageGroupComponent } from './components/manage-group/manage-group.component';
import { CalendarModule } from 'primeng/calendar';
import { TreeTableModule } from 'primeng/treetable';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/primeng';
import { ModalModule } from 'ngx-bootstrap';
import { AddRegistrationChildComponent } from './components/add-registration-child/add-registration-child.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { MoveBidDialogComponent } from './components/move-bid-dialog/move-bid-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        MatRadioModule, MatButtonToggleModule,
        NgxMyDatePickerModule.forRoot(),
        DataTablesModule,
        TreeTableModule,
        DialogModule,
        TableModule,
        DropdownModule,
        CalendarModule,
        ModalModule.forRoot()
    ],
    declarations: [
        OfferEntryGridComponent,
        CellFocus,
        ContextMenuComponent,
        SetCellsValueComponent,
        AdjustCellsValueComponent,
        UploadClearedOfferDialogComponent,
        OfferSummaryConfirmationDialogComponent,
        ChartComponent,
        ConfirmationDialogComponent,
        NotificationComponent,
        NotificationItemComponent,
        AddRegistrationComponent,
        ManageGroupComponent,
        AddRegistrationChildComponent,
        DialogComponent,
        UpdatePriceDialogComponent,
        ProductSelectionComponent,
        MoveBidDialogComponent
    ],
    entryComponents: [
        AddRegistrationComponent,
        ConfirmationDialogComponent,
        AddRegistrationChildComponent,
        ManageGroupComponent,
        DialogComponent
    ],
    exports: [
        OfferEntryGridComponent,
        ContextMenuComponent,
        SetCellsValueComponent,
        AdjustCellsValueComponent,
        UploadClearedOfferDialogComponent,
        OfferSummaryConfirmationDialogComponent,
        ChartComponent,
        NotificationComponent,
        AddRegistrationComponent,
        CellFocus,
        DataTablesModule,
        DialogComponent,
        UpdatePriceDialogComponent,
        ProductSelectionComponent
    ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts